import { AnyAction, Reducer, ReducersMapObject, combineReducers } from "redux";

type ReduxReducer = Reducer<unknown, AnyAction>;
type ReduxReducers = ReducersMapObject<unknown, AnyAction>;
type OptionalReducers = ReduxReducers | null | undefined;

const noopReducer: ReduxReducer = (state = {}) => state;

function buildRootReducer(
  globalReducers: ReduxReducers,
  appReducers: OptionalReducers,
  pageReducers: OptionalReducers,
) {
  return combineReducers({
    global: combineReducers(globalReducers),
    app: appReducers ? combineReducers(appReducers) : noopReducer,
    pages: pageReducers ? combineReducers(pageReducers) : noopReducer,
  });
}

export type { OptionalReducers, ReduxReducers };
export { buildRootReducer };
